import { IAnskaffningsformFilter } from "./IAnskaffningsformFilter";

export class AnskaffningsformFilter implements IAnskaffningsformFilter {
    valda: string[];

    constructor() {
        this.valda = [];
    }
}
